import { Block, Inline, Text, INLINES, BLOCKS, helpers } from '@contentful/rich-text-types'
import { getShortcodeName } from '../shortcode'
import { CodeName } from '../shortcode/types'
import { useIsSectionThemeDark } from '../../../../contexts/section-theme-context'

import styles from '../rich-text.module.scss'

/**
 * Return styles based on the content in the list item.
 * If an embedded inline entry (Item Shortcode for icon) exists in the content, use it to determine which icon we want to show.
 * If no inline entry is present, it will fallback to default bullet styles.
 * @param content Content of the List Item Block
 * @returns List-item styles or undefined
 */
export const useGetListItemStyles = (content: Array<Block | Inline | Text>): string | undefined => {
  const isDarkTheme = useIsSectionThemeDark()
  // Contenful intentionally wraps list-item content with a paragraph tag: https://github.com/contentful/rich-text/issues/126
  // If this wrapper is present, return the actual list-item content.
  const liContent = content[0].nodeType === BLOCKS.PARAGRAPH ? content[0].content : content

  // Find whether an inline embedded entry exists
  const inlineEntry: Inline | undefined = liContent
    .filter(helpers.isInline)
    .find((node) => node.nodeType === INLINES.EMBEDDED_ENTRY)

  if (inlineEntry) {
    const codeName = getShortcodeName(inlineEntry)

    switch (codeName) {
      case CodeName.ListItemIconCheckMark:
        return isDarkTheme ? styles.checklistItemWhite : styles.checklistItemGreen
    }
  }
}
